/// <reference path="../../typings/tsd.d.ts" />

(function () {
    'use strict';

    angular
        .module('SiteRemi')
        .constant('appConfig', {
            debug: true,
            version: '1.0.0',
            reportStateChanges: false,
            stub: ''
        });
})();
